<template>
  <v-app>
    <component :is="currentApp" />
  </v-app>
</template>

<script setup>
import { computed, defineAsyncComponent,watch } from 'vue';
import { useTheme } from 'vuetify'

// Dynamically import the entry point for each app
const CapitalMarkets = defineAsyncComponent(() => import('@/apps/capital/Main.vue'));
const EdTech = defineAsyncComponent(() => import('@/apps/edtech/Main.vue'));
const ArtAuction = defineAsyncComponent(() => import('@/apps/art/Main.vue'));

const theme = useTheme();

const appConfig = computed(() => {
  const host = window.location.hostname;
  if (host.includes('pareekshak')) {
    return {
      component: EdTech,
      theme: 'edtechTheme',
    }
  }
  if (host.includes('blockgen')) {
      return {
      component: ArtAuction,
      theme: 'artauctionTheme'
      }
  }
  // Default to Capital Markets for dipsip.co
  return {
    component: CapitalMarkets,
    theme: 'capitalTheme'
  }
});

const currentApp = computed(() => appConfig.value.component)

watch(
  () => appConfig.value.theme,
  (themeName) => {
    theme.change = themeName
  },
  { immediate: true }
)

</script>